import { Clear, Edit, GetApp } from "@mui/icons-material";
import { Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  downloadAttachment,
  getAttachmentBase64,
} from "../../../../actions/forms";
import {
  downloadAttachmentForm,
  downloadFile,
} from "../../../../utils/filesUtils";
import { getFileSizeAsString } from "../../../../utils/util";
import { StyledUploadedFile } from "../../../styled/file";
import FileView from "./fileView";

const UploadedFiles = ({
  files,
  handleEdit,
  handleDeleteFile,
  configuration,
  selectedDocument,
  disabled,
}) => {
  const dispatch = useDispatch();
  const formsState = useSelector((state) => state.formsState);
  const idSiniestro = formsState.open ? formsState.commonProperties.idSiniestro : null;
  const idArt = formsState.open ? formsState.commonProperties.idArt : null;
  const [openFileView, setOpenFileView] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const isPdf = (file) => {
    return file?.mimeType?.includes("application/pdf");
  };

  const isImage = (file) => {
    return file?.mimeType?.includes("image/");
  };

  const isImageOrPdf = (file) => {
    return isImage(file) || isPdf(file);
  };

  const handleOpenFileView = (file) => {
    if (isImageOrPdf(file)) {
      setSelectedFile(file);
      setOpenFileView(true);
      if (file.base64 === null) {
        dispatch(
          getAttachmentBase64(selectedDocument.nroFormulario, file.nombre, idSiniestro, idArt),
        );
      }
    }
  };

  const handleCloseFileView = () => {
    setSelectedFile(null);
    setOpenFileView(false);
  };

  const handleDownload = (file) => {
    if (selectedDocument) {
      dispatch(
        downloadAttachment(selectedDocument.nroFormulario, file.nombre, idSiniestro, idArt),
      ).then((response) => {
        downloadFile(response.value.data, file.nombre);
      });
    } else {
      downloadAttachmentForm(file);
    }
  };

  const getTipoAdjuntoNombre = (file) => {
    const tipoAdjunto = configuration.typifyAttachmentFile.find(
      (t) => t.tipoAdjunto === file.tipo,
    );
    return tipoAdjunto ? tipoAdjunto.nombre : "";
  };

  return (
    <StyledUploadedFile.Container>
      {files.map((file) => (
        <StyledUploadedFile.Card key={file.filename ?? file.nombre}>
          <StyledUploadedFile.FilesContainer elevation={2}>
            <Typography variant="body2">
              {file.filename ?? file.nombre}
              {" — " + getFileSizeAsString(file.bytes)}
            </Typography>
            {configuration.typifyAttachmentFile && (
              <Typography variant="body2">
                <b>Tipo:</b> {getTipoAdjuntoNombre(file)}
              </Typography>
            )}
            {configuration.showAttachmentObservation && (
              <Typography variant="body2">
                <b>Observaciones:</b> {file.observaciones}
              </Typography>
            )}
          </StyledUploadedFile.FilesContainer>
          <StyledUploadedFile.ActionsContainer elevation={2}>
            <Tooltip
              title={
                isImageOrPdf(file) ? "Ver" : "No es posible ver el archivo"
              }
              arrow>
              <StyledUploadedFile.VisibilityIcon
                onClick={() => handleOpenFileView(file)}
                sx={
                  isImageOrPdf(file)
                    ? StyledUploadedFile.button
                    : StyledUploadedFile.disabledButton
                }
              />
            </Tooltip>
            {!file.base64 && (
              <Tooltip title="Descargar" onClick={() => handleDownload(file)}>
                <GetApp sx={StyledUploadedFile.button} />
              </Tooltip>
            )}
            {configuration.typifyAttachmentFile && (
              <Tooltip title="Editar">
                <Edit
                  onClick={() => {
                    if (!disabled) {
                      handleEdit(file);
                    }
                  }}
                  sx={
                    disabled
                      ? StyledUploadedFile.disabledButton
                      : StyledUploadedFile.button
                  }
                />
              </Tooltip>
            )}
            <Tooltip title="Eliminar">
              <Clear
                onClick={() => {
                  if (!disabled) {
                    handleDeleteFile(file);
                  }
                }}
                sx={
                  disabled
                    ? StyledUploadedFile.disabledButton
                    : StyledUploadedFile.button
                }
              />
            </Tooltip>
          </StyledUploadedFile.ActionsContainer>
        </StyledUploadedFile.Card>
      ))}
      {isImageOrPdf(selectedFile) && (
        <FileView
          file={selectedFile}
          open={openFileView}
          handleClose={handleCloseFileView}
          isImage={isImage(selectedFile)}
        />
      )}
    </StyledUploadedFile.Container>
  );
};

export default UploadedFiles;
